<template>
    <a-drawer
        :title="is_add == '1' ? $t('program.changeProgram') /* 修改日程 */ : $t('program.add_discussion_etc') /* 添加讨论/辩论/其他 */"
        width="800"
        placement="right"
        :closable="true"
        :body-style="{ height: 'calc(100vh - 57px)', paddingBottom: '50px', overflow: 'auto' }"
        :visible="visible"
        @close="handleDrawerClose"
    >
        <a-spin tip="Loading..." :spinning="spinning">
            <!-- 基本信息 -->
            <a-card size="small" :title="$t('program.session_info') /* Session信息 */">
                <date-hall-form
                    v-if="visible"
                    ref="dateHallFormRef"
                    :is_type="is_add == 1 ? 'edit' : 'add'"
                    :sessionInfo="{ ...sessionInfo, ...programInfo, session_id: sessionInfo.id }"
                    :sessionList="sessionList"
                    :hallList="hallList"
                    :dateList="dateList"
                    :is_teaching_form="false"
                    :isSub="isSub"
                />
            </a-card>
            <a-card class="mt15" size="small" :title="$t('program.question') /* 题目 */">
                <a-form :form="form">
                    <a-form-item style="width: 100%" :label="$t('program.cn_title') /* 中文标题 */">
                        <a-input
                            :placeholder="$t('program.p_cn_title') /* 请输入中文标题 */"
                            style="width: 100%"
                            v-decorator="['abstract_title', { rules: [{ required: true, message: $t('program.p_cn_title') /* 请输入中文标题 */ }] }]"
                        ></a-input>
                    </a-form-item>
                    <a-form-item style="width: 100%" :label="$t('program.en_title') /* 英文标题 */">
                        <a-input
                            style="width: 100%"
                            :placeholder="$t('program.p_en_title') /* 请输入英文标题 */"
                            v-decorator="['abstract_title_en', { rules: [{ required: true, message: $t('program.p_en_title') /* 请输入英文标题 */ }] }]"
                        ></a-input>
                    </a-form-item>
                    <a-form-item style="width: 100%" :label="$t('program.fayan_type') /* 发言形式 */">
                        <a-radio-group v-decorator="['type_id', { rules: [{ required: true, message: $t('program.p_fayan_type') /* 请选择发言形式 */ }] }]">
                            <a-radio-button class="mb5" v-for="(item, index) in typeList" :value="item.id" :key="index">
                                {{ $route.params.lang == 'cn' ? item.typename_cn : item.typename_en }}
                            </a-radio-button>
                        </a-radio-group>
                    </a-form-item>
                </a-form>
            </a-card>

            <a-card class="mt15" size="small" :title="$t('program.role_task') /* 角色任务 */" v-if="is_add == 1">
                <a-row :gutter="[15, 15]">
                    <a-col class="duty-item" :span="6" v-for="(item, index) in programInfo.duty_list" :key="index">
                        <a-icon type="close" class="del-icon" @click="handleDelDutyEvent(item.id, index)" />
                        <a-button size="small" style="width: 100%; height: 35px" type="default" @click="handleDutyEvent(item.id)">
                            {{ item.typename_cn }}:
                            <span class="ml5">{{ item.real_name }}</span>
                        </a-button>
                    </a-col>
                    <a-col :span="6">
                        <a-button icon="plus" size="small" style="width: 100%; height: 35px" type="dashed" @click="handleDutyEvent('')">{{ $t('program.add_task.title') /* 添加任务 */ }}</a-button>
                    </a-col>
                </a-row>
            </a-card>
        </a-spin>
        <div
            class="t-r"
            :style="{
                position: 'absolute',
                right: 0,
                bottom: 0,
                height: '50px',
                width: '100%',
                borderTop: '1px solid #e9e9e9',
                padding: '10px 16px',
                background: '#fff',
                textAlign: 'right',
                zIndex: 99
            }"
        >
            <a-button type="default" @click="visible = false">{{ $t('web.cancel' /* 取消 */) }}</a-button>
            <a-button :loading="loading" :disabled="loading" class="ml10" type="primary" @click="handleSubmitEvent">{{ $t('web.ok' /* 确定 */) }}</a-button>
        </div>
        <!-- 添加|修改角色任务 -->
        <add-cn-task-drawer
            ref="addCnTaskDrawerRef"
            :is_show_meeting="false"
            :dateList="dateList"
            :hallList="hallList"
            :sessionList="sessionList"
            @refresh="getProgramInfo(program_id)"
        ></add-cn-task-drawer>
    </a-drawer>
</template>

<script>
import moment from 'moment';
import dateHallForm from './date-hall-form.vue';
import addCnTaskDrawer from './add-cn-task-drawer.vue';
const fileds = ['abstract_title', 'abstract_title_en', 'type_id'];
import pick from 'lodash.pick';
export default {
    components: {
        dateHallForm,
        addCnTaskDrawer
    },
    name: 'addDiscussDrawer',
    props: {
        sessionInfo: {
            default: () => {},
            tyoe: Object
        },
        // session列表
        sessionList: {
            default: () => [],
            type: Array
        },
        // 日期列表
        dateList: {
            default: () => [],
            type: Array
        },
        // 会场列表
        hallList: {
            default: () => [],
            type: Array
        },
        isSub: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            visible: false,
            loading: false,
            spinning: false,
            programInfo: {},
            listObj: {},
            userInfo: {},
            is_add: '1', // 1更新 0新增
            form: this.$form.createForm(this),
            typeList: [],
            program_id: 0
        };
    },
    computed: {},
    watch: {
        sessionInfo: {
            handler(newVal) {
                console.log(newVal);
            }
        }
    },
    methods: {
        show(id) {
            this.visible = true;
            if (id) {
                this.is_add = '1';
                this.getProgramInfo(id);
                this.program_id = id;
            } else {
                this.is_add = '0';
                this.program_id = 0;
            }
            this.getProgramFormList();
        },

        getProgramInfo(program_id) {
            this.$request.get({ url: 'getProgramInfo', data: { program_id } }).then(res => {
                this.programInfo = res.data;
                this.form.setFieldsValue(pick(this.programInfo, fileds));
            });
        },
        getProgramFayanList() {
            this.$request.get({ url: 'getProgramFayanList', data: { type: 4 } }).then(res => {
                this.typeList = res.data;
            });
        },
        //关闭弹窗
        handleDrawerClose() {
            this.$refs.dateHallFormRef.reset();
            this.visible = false;
        },
        formValidate() {
            return new Promise((resolve, reject) => {
                this.form.validateFields((err, values) => {
                    if (!err) {
                        resolve(values);
                    }
                });
            });
        },
        handleSubmitEvent() {
            let arr = [this.$refs.dateHallFormRef.validate(), this.formValidate()];
            Promise.all(arr).then(res => {
                this.spinning = true;
                let data = {};
                res.forEach((item, index) => {
                    for (let i in item) {
                        if (i == 'starttime_slot' || i == 'endtime_slot') {
                            data[i] = moment(item[i]).format('HH:mm');
                        } else {
                            data[i] = item[i];
                        }
                    }
                });
                data.is_abstract = '0';
                data.program_id = this.program_id;
                this.$request
                    .post({ url: 'updateCreateProgram', data })
                    .then(res => {
                        if (res.code == 200) {
                            this.$message.success(this.$t('program.operation_success') /* 操作成功 */);
                            this.handleDrawerClose();
                            this.$emit('update');
                        }
                    })
                    .finally(() => {
                        this.spinning = false;
                    });
            });
        },
        // 删除任务
        handleDelDutyEvent(id, index) {
            let data = {
                program_id: this.program_id,
                duty_id: id
            };
            this.$confirm({
                title: this.$t('web.tips' /* 温馨提示 */),
                content: this.$t('program.delete_task') /* 确认删除该任务吗？ */,
                onOk: () => {
                    this.$request.post({ url: 'delDuty', data }).then(res => {
                        this.$message.success(this.$t('web.delete_success' /* 删除成功 */));
                        this.programInfo.duty_list.splice(index, 1);
                    });
                }
            });
        },
        getProgramFormList() {
            this.$request.get({ url: 'getProgramFormList', data: { add_language: 'cn', session_id: this.sessionInfo.id } }).then(res => {
                this.listObj = res.data;
            });
        },
        // 添加|编辑任务
        handleDutyEvent(duty_id) {
            let data = {
                id: this.sessionInfo.id,
                lang: 'cn',
                type: 4,
                duty_id: duty_id || '',
                program_id: this.program_id && this.program_id != 0 ? this.program_id : this.sessionInfo.id
            };
            this.$refs.addCnTaskDrawerRef.show(data);
        }
    },
    mounted() {
        this.getProgramFayanList();
    }
};
</script>
<style lang='less' scoped>
/deep/.ant-drawer-body {
    background: #f8fafe;
}
:deep(.ant-card-head) {
    background: #fafafa;
    .ant-card-head-title {
        font-weight: bold;
    }
}
.duty-item {
    position: relative;
    .del-icon {
        display: none;
        position: absolute;
        right: 0px;
        top: 0px;
        background: red;
        color: #ffffff;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        text-align: center;
        padding: 0;
        z-index: 666;
        padding-top: 3px;
        font-weight: bold;
        cursor: pointer;
        transition: all 0.3 linear;
    }
    &:hover {
        .del-icon {
            display: block;
        }
    }
}
</style>